import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Payment, PaymentType, PaymentStatus } from '../../models/contract';
import { ImmobilierService } from '../../services/immobilier.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-add-edit-payment-dialog',
  templateUrl: './add-edit-payment-dialog.component.html',
  styleUrls: ['./add-edit-payment-dialog.component.css']
})
export class AddEditPaymentDialogComponent implements OnInit {

  payment: Payment;
  isNew: boolean = true;
  contractId: number;

  paymentTypes: PaymentType[] = ['loyer', 'charges', 'depot', 'acompte', 'solde', 'frais_agence'];
  paymentStatuses: PaymentStatus[] = ['en_attente', 'paye', 'retard', 'impaye', 'partiel'];
  paymentMethods: string[] = ['virement', 'cheque', 'especes', 'mobile_money'];

  constructor(
    public dialogRef: MatDialogRef<AddEditPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private immobilierService: ImmobilierService,
    private snackBar: MatSnackBar
  ) {
    this.contractId = data.contractId;

    if (data && data.payment) {
      this.payment = { ...data.payment };
      this.isNew = false;
    } else {
      this.isNew = true;

      let defaultType: PaymentType = 'loyer';
      if (data.contractType === 'vente') {
        defaultType = 'acompte'; // or 'solde'
      }

      this.payment = {
        id: 0,
        contractId: this.contractId,
        amount: 0,
        paymentDate: new Date(),
        dueDate: new Date(),
        type: defaultType,
        status: 'paye',
        paymentMethod: 'especes',
        reference: '',
        notes: ''
      };
    }
  }

  ngOnInit(): void { }

  save(): void {
    if (this.isNew) {
      this.immobilierService.createPayment(this.payment).subscribe({
        next: (res) => {
          this.snackBar.open('Paiement enregistré avec succès', 'Fermer', { duration: 3000, panelClass: ['mat-primary'] });
          // Ensure we return the payment object so it can be added to UI immediately if needed
          this.dialogRef.close(Object.assign({}, this.payment, { id: res.id || this.payment.id }));
        },
        error: (err) => {
          console.error(err);
          this.snackBar.open('Erreur lors de la création du paiement', 'Fermer', { duration: 3000, panelClass: ['mat-warn'] });
        }
      });
    } else {
      this.immobilierService.updatePayment(this.payment.id, this.payment).subscribe({
        next: (res) => {
          this.snackBar.open('Paiement mis à jour avec succès', 'Fermer', { duration: 3000, panelClass: ['mat-primary'] });
          this.dialogRef.close(this.payment);
        },
        error: (err) => {
          console.error(err);
          this.snackBar.open('Erreur lors de la mise à jour', 'Fermer', { duration: 3000, panelClass: ['mat-warn'] });
        }
      });
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
